import { LamnaOverType } from "@/composables/KundserviceAppApiClient";

export function shouldRequireInternKommentar(
  lamnaOverTill: LamnaOverType | undefined,
) {
  switch (lamnaOverTill) {
    case LamnaOverType.Kundservice:
    case LamnaOverType.Collectum:
    case LamnaOverType.Radgivningstjansten:
    case LamnaOverType.SupportForInformatorer:
    case LamnaOverType.Webbgruppen:
    case LamnaOverType.Klagomal:
    case LamnaOverType.Legal:
      return false;
    default:
      return true;
  }
}

export function shouldRequireEmail(lamnaOverTill: LamnaOverType | undefined) {
  return (
    lamnaOverTill === LamnaOverType.Radgivningstjansten ||
    lamnaOverTill === LamnaOverType.SupportForInformatorer ||
    lamnaOverTill === LamnaOverType.Webbgruppen ||
    lamnaOverTill === LamnaOverType.Klagomal ||
    lamnaOverTill === LamnaOverType.Legal
  );
}

export function showSaveButton(
  lamnaOverTill: LamnaOverType | undefined,
  isLinkedArende: boolean,
) {
  if (
    (lamnaOverTill === undefined || lamnaOverTill === LamnaOverType.Nej) &&
    !isLinkedArende
  ) {
    return false;
  }

  switch (lamnaOverTill) {
    case LamnaOverType.Fora:
    case LamnaOverType.Alecta:
    case LamnaOverType.AfaForsakring:
    case LamnaOverType.CollectumForetag:
      return false;

    default:
      return true;
  }
}

export function showSaveCloseButton(lamnaOverTill: LamnaOverType | undefined) {
  if (lamnaOverTill === undefined) {
    return true;
  }

  switch (lamnaOverTill) {
    case LamnaOverType.Fora:
    case LamnaOverType.Alecta:
    case LamnaOverType.AfaForsakring:
    case LamnaOverType.CollectumForetag:
      return true;

    case LamnaOverType.Kundservice:
    case LamnaOverType.Collectum:
    case LamnaOverType.Radgivningstjansten:
    case LamnaOverType.SupportForInformatorer:
    case LamnaOverType.Webbgruppen:
    case LamnaOverType.Klagomal:
    case LamnaOverType.Legal:
      return false;

    default:
      return true;
  }
}
